export const sheep_64 = require('./quickFacts/sheep_64.png');
export const wool_64 = require('./quickFacts/wool_64.png')
export const knitting_64 = require('./quickFacts/knitting_64.png');
export const shipped_64 = require('./quickFacts/shipped_64.png');
export const planet_earth_64 = require('./quickFacts/planet_earth_64.png');
export const globalonline_64 = require('./quickFacts/globalonline_64.png');
export const globalonline2_64 = require('./quickFacts/globalonline2_64.png');
export const globalonline2_128 = require('./quickFacts/globalonline2_128.png');
export const devices_64 = require('./quickFacts/devices_64.png');
export const devices2_64 = require('./quickFacts/devices2_64.png');
export const devices2_128 = require('./quickFacts/devices2_128.png');


export const financialprofit_64 = require('./quickFacts/financialprofit_64.png')
export const financialprofit2_64 = require('./quickFacts/financialprofit2_64.png')
export const financialprofit2_128 = require('./quickFacts/financialprofit2_128.png')


export const sheep_color_64 = require('./quickFacts/sheep_color_64.png');
export const planet_earth_color_64 = require('./quickFacts/planet_earth_color_64.png');
export const planet_earth_white_64 = require('./quickFacts/planet_earth_white_64.png');
export const planet_earth_white_128 = require('./quickFacts/planet_earth_white_128.png');


export const shipped_color_64 = require('./quickFacts/shipped_color_64.png');
export const knitting_color_64 = require('./quickFacts/knitting_color_64.png');


export const sheep_color_128 = require('./quickFacts/sheep_color_128.png');
export const planet_earth_color_128 = require('./quickFacts/planet_earth_color_128.png');
export const shipped_color_128 = require('./quickFacts/shipped_color_128.png');
export const knitting_color_128 = require('./quickFacts/knitting_color_128.png');


export const facebook_24 = require('./socialMedia/facebook_24.png');
export const facebook_16 = require('./socialMedia/facebook_16.png');

export const logo_stock_16 = require('./logo/logo_stock_16.png')
export const logo_stock_24 = require('./logo/logo_stock_24.png')
export const logo_stock_32 = require('./logo/logo_stock_32.png')
export const logo_stock_64 = require('./logo/logo_stock_64.png')
export const logo_black_24 = require('./logo/logo_black_24.png')
export const investitum_logo = require('./logo/investitum_logo.png')


export const logo_color_1_64 = require('./logo/logo_color_1_64.png')
